import { environmentConfig } from "@src/appV2/environment";
import { Worker } from "@src/appV2/Worker/api/types";
import { logApiFailureEvent } from "@src/lib/analytics";
import { PaymentAccountInfo } from "@src/lib/interface";
import request from "superagent";

import { getAuthHeader } from "../superagent";

interface SignedContractorAgreementParams {
  agentId: string;
  agreementVersion: string | number;
  signature: string | undefined;
  forceReSignAgreement: boolean | undefined;
}

const signedContractorAgreement = async (
  params: SignedContractorAgreementParams
): Promise<Worker> => {
  try {
    const { agentId, agreementVersion, signature, forceReSignAgreement } = params;

    const { body } = await request
      .patch(
        `${environmentConfig.REACT_APP_WORKER_SERVICE_URL}/agentprofile/signContractorAgreement`
      )
      .set(await getAuthHeader())
      .send({ agentId, agreementVersion, forceReSignAgreement, signature: signature ?? null });
    return body;
  } catch (error) {
    logApiFailureEvent(error);
    throw error;
  }
};

const generatePaymentServiceOnboardingLink = async (
  id: string,
  data: { refreshUrl: string; returnUrl: string }
): Promise<string> => {
  try {
    const paymentServiceUser = await request
      .post(`${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${id}/generate-account-link`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ text }) => text);
    return paymentServiceUser;
  } catch (error) {
    console.log(error);
    logApiFailureEvent(error);
    throw error;
  }
};

const generateExpressSignInLinkToStripe = async (
  id: string,
  data: { returnUrl: string }
): Promise<string> => {
  try {
    const paymentServiceUser = await request
      .post(
        `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${id}/generate-express-account-link`
      )
      .set(await getAuthHeader())
      .send(data)
      .then(({ text }) => text);
    return paymentServiceUser;
  } catch (error) {
    console.log(error);
    logApiFailureEvent(error);
    throw error;
  }
};

interface CreatePaymentServiceAccount {
  agentId: string;
  email: string;
  msa: string;
  individual: {
    firstName?: string;
    lastName?: string;
    phone?: string;
    birthday?: string;
    address?: {
      line1?: string;
      postalCode?: string;
      city?: string;
      state?: string;
    };
  };
}

/**
 *
 * @deprecated use useCreatePaymentServiceAccount(...) mutation hook instead.
 */
const createPaymentServiceAccount = async (
  data: Partial<CreatePaymentServiceAccount>
): Promise<PaymentAccountInfo> => {
  try {
    const paymentServiceAccount = await request
      .post(`${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ body }) => body);
    return paymentServiceAccount;
  } catch (error) {
    console.log(error);
    logApiFailureEvent(error);
    throw error;
  }
};

export {
  generatePaymentServiceOnboardingLink,
  generateExpressSignInLinkToStripe,
  createPaymentServiceAccount,
  signedContractorAgreement,
};
